import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import financialYearService from '../services/financial-year.service';


export const fetchFinancialYearList = createAsyncThunk(
  'financialYear/fetchFinancialYearList',
  async ({ page, pagesize, search }, { getState, rejectWithValue }) => {
    try {
      const { financialYear } = getState();
      
      if (financialYear.data.length > 0) {
        return rejectWithValue('Already loaded');
      }
      const response = await financialYearService.getFinancialYearList(
        page,
        pagesize,
        search
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return rejectWithValue(message);
    }
  },
);

export const changeFinancialYear = createAsyncThunk(
  'financialYear/changeFinancialYear',
  async (id, thunkAPI) => {
    try {
      const response = await financialYearService.changeFinancialYear(id); // Ensure `id` is used here
      return response.data; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


const initialState = {
  data: [],
  totalPages: 0,
  currentPage: 1,
  totalRecord: 0,
  error: null,
  loading: false
};

const financialYearSlice = createSlice({
  name: 'financialYear',
  initialState,
  reducers: {
    resetFinancialYearData: (state) => {
      state.data = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchFinancialYearList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFinancialYearList.fulfilled, (state, action) => {
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload?.results?.data || [];
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.loading = false;
      })
      .addCase(fetchFinancialYearList.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(changeFinancialYear.pending, state => {
        state.loading = true;
      })
      .addCase(changeFinancialYear.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;
      })
      .addCase(changeFinancialYear.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
  },
});


export const { resetFinancialYearData } = financialYearSlice.actions;
export default financialYearSlice.reducer;


